<svg width="124" height="140" viewBox="0 0 124 140" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M61.6727 123.436C95.7336 123.436 123.345 95.8039 123.345 61.718C123.345 27.6321 95.7336 0 61.6727 0C27.6118 0 0 27.6321 0 61.718C0 95.8039 27.6118 123.436 61.6727 123.436Z"
    fill="#FCBD80"
  />
  <path d="M61.6721 140L46.2539 121.016L61.6721 97.1909L77.1658 121.016L61.6721 140Z" fill="#FCBD80" />
  <path d="M65.7541 71.5506H57.6671L54.5684 29.6489H68.8528L65.7541 71.5506Z" fill="#004249" />
  <path d="M67.4928 81.6104H55.8535V92.1236H67.4928V81.6104Z" fill="#004249" />
</svg>
